import React, { Fragment, useEffect, useState } from "react"
import { compose } from "redux"
import { Empty, Popover, Spin } from "antd"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import PropTypes from "prop-types"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { QuestionCircleFilled } from "@ant-design/icons"
import { Doughnut } from "react-chartjs-2"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectDataEnps, makeSelectIsLoading } from "./selectors"
import { getDataEnpsWatcher } from "./actions"

import Carita_roja from "../../../images/Carita_roja.svg"
import Carita_amarilla from "../../../images/Carita_amarilla.svg"
import Carita_verde from "../../../images/Carita_verde.svg"
import imgenps10 from "../../../images/enps10img.svg"
import { validate } from "../../../utils/functions"
import PopoverBenchmark from "../../../Reports/components/PopoverBenchmark"
import {
  isAmbassadorActive,
  isModuleBySlug,
} from "../../../utils/storage"
import { BENCHMARK, HISTORICAL_ANALYSIS } from "../../../utils/constants"
import { get } from "lodash"
import { ArrowDownIcon } from "../../../icons/svg/iconArrowDown"
import { ArrowUpIcon } from "../../../icons/svg/iconArrowUp"
import { loadTexts, sanitize, loadImage } from "../../../utils/i18n"

import "../../../Reports/components/SummaryWidgets/components/WidgetChartEnps/index.less"

export function WidgetChartEnps(props) {
  const intl = loadTexts("reports_general_view")
  const sectionTitle =
    intl.reportAmbassador.engagementMeasurement.widgetChartEnps.sectionTitle
  const sectionBody =
    intl.reportAmbassador.engagementMeasurement.widgetChartEnps.sectionBody
  const sectionFooter =
    intl.reportAmbassador.engagementMeasurement.widgetChartEnps.sectionFooter
  const intlWidgetChartEnps =
    intl.reportAmbassador.engagementMeasurement.widgetChartEnps

  const [climeChart, setClimeChart] = useState({
    data: {
      datasets: [
        {
          data: [30, 60, 10],
          borderWidth: 0,
          backgroundColor: ["#5ad0b7", "#f9bf78", "#e88282"],
          weight: 0.3,
        },
      ],
      text: "26%",
    },
    options: {
      maintainAspectRatio: false,
      cutoutPercentage: 80,
      responsive: false,
      tooltips: { enabled: false },
      legend: { display: false },
      elements: {
        center: {
          text: "0%",
          color: "#4F4F4F",
          fontStyle:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif, Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans"',
          sidePadding: 20,
          minFontSize: 25,
          lineHeight: 30,
        },
      },
    },
    plugins: [
      {
        beforeDraw(chart) {
          if (chart.config.options.elements.center) {
            var ctx = chart.chart.ctx
            var centerConfig = chart.config.options.elements.center
            var fontStyle = centerConfig.fontStyle || "Arial"
            var txt = centerConfig.text
            var color = centerConfig.color || "#000"
            var maxFontSize = centerConfig.maxFontSize || 75
            var sidePadding = centerConfig.sidePadding || 20
            var sidePaddingCalculated =
              (sidePadding / 100) * (chart.innerRadius * 2)
            ctx.font = `20px ${fontStyle}`
            var stringWidth = ctx.measureText(txt).width
            var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated
            var widthRatio = elementWidth / stringWidth
            var newFontSize = Math.floor(30 * widthRatio)
            var elementHeight = chart.innerRadius * 2
            var fontSizeToUse = Math.min(
              newFontSize,
              elementHeight,
              maxFontSize
            )
            var minFontSize = centerConfig.minFontSize
            var lineHeight = centerConfig.lineHeight || 25
            var wrapText = false
            if (minFontSize === undefined) {
              minFontSize = 20
            }
            fontSizeToUse = minFontSize
            ctx.textAlign = "center"
            ctx.textBaseline = "middle"
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
            ctx.font = `600 ${fontSizeToUse}px ${fontStyle}`
            ctx.fillStyle = color
            if (!wrapText) {
              ctx.fillText(txt, centerX, centerY)
              return
            }
            var words = txt.split(" ")
            var line = ""
            var lines = []
            for (var n = 0; n < words.length; n++) {
              var testLine = `${line + words[n]} `
              var metrics = ctx.measureText(testLine)
              var testWidth = metrics.width
              if (testWidth > elementWidth && n > 0) {
                lines.push(line)
                line = `${words[n]} `
              } else {
                line = testLine
              }
            }
            centerY -= (lines.length / 2) * lineHeight
            for (var n = 0; n < lines.length; n++) {
              ctx.fillText(lines[n], centerX, centerY)
              centerY += lineHeight
            }
            ctx.fillText(line, centerX, centerY)
          }
        },
      },
    ],
  })

  useEffect(() => {
    initGetData()
  }, [props.idMeasure, props.idDivisionSelected, props.selectedSegment])

  useEffect(() => {
    if (validate.exist(props.dataEnps)) {
      const climeChartAux = { ...climeChart }
      climeChartAux.data.datasets[0].data = [
        parseInt(props.dataEnps.value, 0),
        parseInt(props.dataEnps.value_middle, 0),
        parseInt(props.dataEnps.value_low, 0),
      ]
      climeChartAux.data.text =
        props.dataEnps.value_enps == 0
          ? "N/A"
          : `${parseInt(props.dataEnps.value_enps, 10)}%`
      climeChartAux.options.elements.center.text =
        props.dataEnps.value_enps == 0
          ? "N/A"
          : `${parseInt(props.dataEnps.value_enps, 10)}%`
      setClimeChart(climeChartAux)
    }
  }, [props.dataEnps])

  const initGetData = () => {
    const {
      idMeasure,
      getDataEnps,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props
    getDataEnps({
      isHome: true,
      id_measure: idMeasure,
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    })
  }

  const renderTitle = () => {
    const { measureGeneral } = props
    const language = localStorage.getItem("language")

    return (
      <div className="WidgetChartEnps-header">
        {language == "es" ? (
          <>
            <span style={{ fontWeight: 600 }}>{sectionTitle.header} </span>
            <b>{measureGeneral.id_survey_type === 1 ? "eNPS" : "NPS"}</b>
          </>
        ) : (
          <>
            <b>{measureGeneral.id_survey_type === 1 ? "eNPS" : "NPS"}</b>
            <span style={{ fontWeight: 600 }}> {sectionTitle.header}</span>
          </>
        )}
        <Popover
          placement="bottom"
          overlayClassName="popover-title-center"
          title={
            measureGeneral.id_survey_type === 1
              ? sectionTitle.popover.title1
              : sectionTitle.popover.title2
          }
          trigger="hover"
          content={
            <div style={{ maxWidth: 532 }}>
              {validate.exist(props.dataEnps) &&
                props.dataEnps.enps_scale === 5 &&
                (measureGeneral.id_survey_type === 1 ? (
                  <p style={{ textAlign: "justify" }}>
                    {sanitize(sectionTitle.popover.body.enpsScale5)}
                  </p>
                ) : (
                  <p style={{ textAlign: "justify" }}>
                    {sanitize(sectionTitle.popover.body.npsDescription)}
                  </p>
                ))}
              {validate.exist(props.dataEnps) &&
                props.dataEnps.enps_scale === 10 &&
                (measureGeneral.id_survey_type === 1 ? (
                  <p style={{ textAlign: "justify" }}>
                    {sanitize(sectionTitle.popover.body.enpsScale10)}
                  </p>
                ) : (
                  <p style={{ textAlign: "justify" }}>
                    {sanitize(sectionTitle.popover.body.npsDescription)}
                  </p>
                ))}
              <p className="text-left">
                <b>{sectionTitle.popover.body.howIsCalculate}</b>
              </p>
              <div className="eNPSToolTip__formula">
                <span className="nps-label">
                  {measureGeneral.id_survey_type === 1 ? "eNPS" : "NPS"}
                </span>
                <span> = </span>
                <span style={{ color: "#5ad0b7" }}>
                  {sectionTitle.popover.body.promotersPercent}
                </span>
                <span> - </span>
                <span style={{ color: "#e88282" }}>
                  {sectionTitle.popover.body.detractorsPercent}
                </span>
              </div>
              <div style={{ margin: "20px 0" }}>
                {validate.exist(props.dataEnps) &&
                  props.dataEnps.enps_scale === 5 && (
                    <img
                      src={loadImage(intlWidgetChartEnps.urlImageEnps5)}
                      width="100%"
                    />
                  )}
                {validate.exist(props.dataEnps) &&
                  props.dataEnps.enps_scale === 10 && (
                    <img
                      src={loadImage(intlWidgetChartEnps.urlImageEnps10)}
                      width="100%"
                    />
                  )}
              </div>
            </div>
          }
        >
          {" "}
          <QuestionCircleFilled
            style={{
              color: "#D8D8D8",
              verticalAlign: "baseline",
              fontSize: "14px",
            }}
          />
        </Popover>
      </div>
    )
  }

  const renderBody = () => {
    return (
      <div className="WidgetChartEnps-body">
        <div className="WidgetChartEnps-body-padding">
          <div className="WidgetChartEnps-body-chart">
            <Doughnut
              data={climeChart.data}
              options={climeChart.options}
              width={112}
              height={112}
              plugins={climeChart.plugins}
            >
              <div className="WidgetChartEnps-body-chart-text">
                {climeChart.data.text}
              </div>
            </Doughnut>
          </div>
          <div className="WidgetChartEnps-body-legend">
            <div className="WidgetChartEnps-body-legend__red">
              <div>
                <img width={16} height={16} src={Carita_roja} />
                <span className="porcentaje">
                  {props.dataEnps.value_low_visible || "-"}
                </span>
              </div>
              <div className="nombre">
                {sectionBody.detractors}
                <span className="total">
                  ({props.dataEnps.employees_low || 0})
                </span>
              </div>
            </div>
            <div className="WidgetChartEnps-body-legend__yellow">
              <div>
                <img width={16} height={16} src={Carita_amarilla} />
                <span className="porcentaje">
                  {" "}
                  {props.dataEnps.value_middle_visible || "-"}
                </span>
              </div>
              <div className="nombre">
                {sectionBody.passives}
                <span className="total">
                  ({props.dataEnps.employees_middle || 0})
                </span>
              </div>
            </div>
            <div className="WidgetChartEnps-body-legend__green">
              <div>
                <img width={16} height={16} src={Carita_verde} />
                <span className="porcentaje">
                  {props.dataEnps.value_visible || "-"}
                </span>
              </div>
              <div className="nombre">
                {sectionBody.promoters}
                <span className="total">
                  ({props.dataEnps.employees_top || 0})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (props.isLoading) {
    return (
      <Fragment>
        <div className="loadingSpin WidgetChartEnpsLoadingSpin">
          <Spin size="large" />
        </div>
      </Fragment>
    )
  }

  const renderComparative = () => {
    const { dataEnps, measureGeneral } = props
    const { calculate_comparative, benchmark } = dataEnps
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)

    let isBenchmarkRender = true
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      isBenchmarkRender = false
    }
    if (!validate.exist(benchmark) || !benchmark.show || !isBenchmark) {
      isBenchmarkRender = false
    }

    if (
      !validate.exist(calculate_comparative) ||
      !calculate_comparative.show ||
      !isHistoricalAnalysis
    ) {
      return null
    }
    return (
      <div
        className={`WidgetChartEnps-footer-comparative ${
          isBenchmarkRender ? "benchmark" : ""
        }`}
      >
        <div className="WidgetChartEnps-footer-comparative-title">
          {sectionFooter.comparative.lastMeasure}
        </div>
        <div className="WidgetChartEnps-footer-comparative-value">
          <div className="WidgetChartEnps-footer-comparative-value-current">
            {`${Math.round(calculate_comparative.prev_value)}%`}
          </div>
          <div
            className={`WidgetChartEnps-footer-comparative-value-comparative ${
              calculate_comparative.level === true
                ? " green"
                : calculate_comparative.level === false
                ? " red"
                : ""
            }`}
          >
            <div>{calculate_comparative.value}</div>
            {calculate_comparative.level === true ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : calculate_comparative.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderBenchmark = () => {
    const { dataEnps, measureGeneral } = props
    const { benchmark } = dataEnps
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      return null
    }
    if (!validate.exist(benchmark) || !benchmark.show || !isBenchmark) {
      return null
    }
    return (
      <div className="WidgetChartEnps-footer-benchmark">
        <div className="WidgetChartEnps-footer-benchmark-title">
          <PopoverBenchmark
            isGlobalBenchmark={measureGeneral.is_global_benchmark}
          />
        </div>
        <div className="WidgetChartEnps-footer-benchmark-value">
          <div className="WidgetChartEnps-footer-benchmark-value-current">
            {benchmark.value}
          </div>
          <div
            className={`WidgetChartEnps-footer-benchmark-value-comparative ${
              benchmark.level === true
                ? " green"
                : benchmark.level === false
                ? " red"
                : ""
            }`}
          >
            <div>{`${benchmark.variation}%`}</div>
            {benchmark.level === true ? (
              <ArrowUpIcon />
            ) : benchmark.level === false ? (
              <ArrowDownIcon />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderFooter = () => {
    const { dataEnps, measureGeneral } = props
    const { calculate_comparative, benchmark } = dataEnps
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    let isComparativeRender = true

    let isBenchmarkRender = true
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      isBenchmarkRender = false
    }
    if (!validate.exist(benchmark) || !benchmark.show || !isBenchmark) {
      isBenchmarkRender = false
    }

    if (
      !validate.exist(calculate_comparative) ||
      !calculate_comparative.show ||
      !isHistoricalAnalysis
    ) {
      isComparativeRender = false
    }
    if (!isComparativeRender && !isBenchmarkRender) {
      return null
    }
    return (
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div className="WidgetChartEnps-footer">
          {renderComparative()}
          {renderBenchmark()}
        </div>
      </div>
    )
  }

  if (!validate.exist(props.dataEnps)) {
    return (
      <Fragment>
        <div className="WidgetResumeEnps boxShadow">
          {renderTitle()}
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No se pudo cargar este indicador"
          />
        </div>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <div className="WidgetResumeEnps boxShadow">
        {renderTitle()}
        {renderBody()}
        {renderFooter()}
      </div>
    </Fragment>
  )
}

WidgetChartEnps.propTypes = {
  idMeasure: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataEnps: PropTypes.object,
  measureGeneral: PropTypes.object,
  isLoading: PropTypes.bool,
  getDataEnps: PropTypes.func,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  dataEnps: makeSelectDataEnps(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDataEnps: (params) => dispatch(getDataEnpsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetChartEnpsV2", reducer })
const withSaga = injectSaga({ key: "widgetChartEnpsV2", saga })

export default compose(withReducer, withSaga, withConnect)(WidgetChartEnps)
